import React, { FC } from "react";
import css from "./styles.module.scss";
import { useLegalEntity } from "./hook/useLegalEntity";

const LegalEntity: FC = () => {
  const { adress } = useLegalEntity();

  return (
    <div className={css.LegalEntity}>
      {`<div style="padding: 10px; color: #000;">
      <center>
      ${adress}
        <br />
        <a href="policy.html" class="policy" target="_blank" rel="noopener noreferrer" style="color: inherit;">Privacy policy</a>
      </center>
    </div>`}
    </div>
  );
};

export default LegalEntity;
